import ActivityService from "../../../services/ActivityService";
import { ActivityListResponse } from "./entities/AcitivityListResponse";
import { ActivityPendingResponse } from "./entities/AcitivityPendingResponse";
import ModalService from "../../shared/bootstrap/modal/Modal";
import { FilesAttached } from "./components/NewComment";
import TaskService from "../../../services/TaskSerivce";
import { ToastService } from "../../shared/bootstrap/Toast";
import { TranslationService } from "../../../services/TranslationService";
import { ActivityHistoryType } from "../../shared/enums";
import TooltipComponent from "../../shared/TooltipComponent";
import FileService from "../../../services/FileService";
import { Client } from "../entities/ClientGetResponse";
import { ModalTypeDefault } from "../ClientDetail";
import { Cast } from "../../../utils/Utils";
import { ScheduledTaskService } from "../../../services/ScheduledTaskService";
import "./AttachmentsModal.css";
import { getError, isAbortError } from "../../../utils/RequestUtils";
import { ActivityHistoryManager } from "./activityManager/ActivityHistoryManager";

export const ActivityHistory = ({
  personid,
  person,
  emailAddress,
  groupid = undefined,
  setReloads = undefined,
  openModalDefault = "",
  reload
}: {
  personid: string;
  person?: Client;
  emailAddress: string;
  groupid?: number;
  setReloads?: { activity: () => void };
  openModalDefault?: ModalTypeDefault | string;
  reload: () => void;
}) => {
  return (
    <ActivityHistoryManager
      personid={personid}
      person={person}
      emailAddress={emailAddress}
      groupid={groupid}
      setReloads={setReloads}
      openModalDefault={openModalDefault}
      reload={reload}
    />
  );
};

export const deleteActivityAction = (
  id: number,
  title: string,
  message: string,
  reload: () => void,
  onError?: () => void
) => {
  return {
    icon: "fa-trash",
    classes: "text-secondary",
    onClick: () => {
      ModalService.showDefaultModal({
        title: title,
        message: message,
        acceptButtonLabel: TranslationService.translate.Delete,
        acceptButtonClassName: "btn btn-danger",
        onAcceptClick: async () => {
          const result = await ActivityService.delete(id.toString());

          if (result instanceof Error) {
            if (isAbortError(result)) {
              return;
            }
            const { status } = getError(result);
            if (status === 409) {
              ToastService.showToast(
                TranslationService.translate.EmailNotFound,
                undefined,
                "warning"
              );
            } else {
              ToastService.showToast(
                TranslationService.translate.ErrorProcessingRequest,
                undefined,
                "danger"
              );
            }
            return;
          } else {
            ToastService.showToast(
              TranslationService.translate.EmailDeletedSuccess,
              undefined,
              "success"
            );
          }

          reload && reload();
        }
      });
    },
    tooltip: TranslationService.translate.Delete
  };
};

export const deleteTaskAction = (
  id: number,
  reload: () => void,
  onError?: () => void
): { icon: string; classes: string; onClick: () => void } => {
  return {
    icon: "fa-trash",
    classes: "text-secondary",
    onClick: () => {
      ModalService.showDefaultModal({
        title: TranslationService.translate.DeleteActivity,
        message: TranslationService.translate.AreYouSureDeleteActivity,
        acceptButtonLabel: TranslationService.translate.Delete,
        onAcceptClick: async () => {
          const result = await TaskService.deleteSingle(id);
          if (result instanceof Error) {
            onError && onError();
            return;
          }
          reload && reload();
        }
      });
    }
  };
};

export const deleteScheduledTaskAction = (
  id: number,
  reload: () => void,
  onError?: () => void
): { icon: string; classes: string; onClick: () => void } => {
  return {
    icon: "fa-trash",
    classes: "text-secondary",
    onClick: () => {
      ModalService.showDefaultModal({
        title: TranslationService.translate.DeleteActivity,
        message: TranslationService.translate.AreYouSureDeleteActivity,
        acceptButtonLabel: TranslationService.translate.Delete,
        onAcceptClick: async () => {
          const result = await ScheduledTaskService.deleteScheduledTask(id);
          if (result instanceof Error) {
            onError && onError();
            return;
          }
          reload && reload();
        }
      });
    }
  };
};

export const DisplayFileIcon = (
  data:
    | ActivityListResponse.Item
    | ActivityPendingResponse.Task
    | ActivityPendingResponse.Mail
    | ActivityPendingResponse.Scheduledtask,
  type: ActivityHistoryType,
  list: boolean
) => {
  if ("item" in data) {
    data = Cast<{ item: ActivityListResponse.Item }>(data).item;
  }

  const download = (fileId: string, fileName: string) => {
    switch (type) {
      // [FALLTHROUGH] Comment uses the same endpoint as email
      case ActivityHistoryType.comment:
      case ActivityHistoryType.whatsapp:
      case ActivityHistoryType.email:
        FileService.downloadFileMessage(
          fileId,
          (data as ActivityListResponse.Item).ID ??
            (data as ActivityPendingResponse.Mail).MessageID,
          fileName
        );
        break;
      case ActivityHistoryType.scheduledTask:
        const scheduledTaskId = (data as ActivityPendingResponse.Scheduledtask)
          .ScheduledTaskID;
        if (scheduledTaskId != null) {
          FileService.downloadTask(
            fileId,
            scheduledTaskId.toString(),
            fileName
          );
        }
        break;
      case ActivityHistoryType.pendingTask:
      case ActivityHistoryType.task:
        // Puede ser ActivityListResponse.Item (con ID) o ActivityPendingResponse.Task (con TaskID)
        const taskId =
          "TaskID" in data &&
          (data as ActivityPendingResponse.Task).TaskID != null
            ? (data as ActivityPendingResponse.Task).TaskID
            : "ID" in data
              ? (data as ActivityListResponse.Item).ID
              : null;
        if (taskId != null) {
          FileService.downloadTask(fileId, taskId.toString(), fileName);
        }
        break;
      case ActivityHistoryType.sms:
        break;
    }
  };

  let files: { fileName: string; id: string; inline: boolean }[] = [];

  if ("Attachments" in data) {
    files.push(
      ...data.Attachments.map((x) => ({
        fileName: x.Filename,
        id: x.AttachmentID.toString(),
        inline: x.Inline ?? false
      }))
    );
  }
  if ("files" in data) {
    files.push(
      ...data.files.map((x) => ({
        fileName: x.fileName,
        id: x.id,
        inline: x.inline ?? false
      }))
    );
  }
  if (files.length > 0) {
    files = files.filter((el) => !el.inline);
    return (
      <div className="d-flex align-items-center">
        {files.length > 0 ? (
          <TooltipComponent title={TranslationService.translate.AttachedFile}>
            <i className="far fa-fw fa-paperclip activity-icon-color my-2" />
          </TooltipComponent>
        ) : null}
        {list ? (
          <div className="pointer d-flex">
            <FilesAttached
              files={files}
              downloadFile={download}
              canEdit={files.length > 0}
            />
          </div>
        ) : null}
      </div>
    );
  }
};

export default ActivityHistory;
